import { render, staticRenderFns } from "./SampleFooter.vue?vue&type=template&id=7e2a54fb&scoped=true"
import script from "./SampleFooter.vue?vue&type=script&lang=js"
export * from "./SampleFooter.vue?vue&type=script&lang=js"
import style0 from "./SampleFooter.vue?vue&type=style&index=0&id=7e2a54fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2a54fb",
  null
  
)

export default component.exports